import Isotope from 'isotope-layout';

/*-------------------------------------------*/
/* ISOTOPE FILTERING
/*-------------------------------------------*/
export default function isotopeFilter() {

	var header = document.querySelector('header');
	var main = document.querySelector('main');

	var isotopeGrid = document.querySelector('.isotope');

	if (!isotopeGrid) {

		return;

	}

	// CREATE MARKUP
	// Create Desktop Filter Bar and append to Header element
	var div = document.createElement('div');
	div.setAttribute('id', 'filter-bar');
	var filterDesktop = div;

	var h4 = document.createElement('h4');
	h4.innerText = 'Filter: ';

	var button = document.createElement('button');
	button.setAttribute('type', 'button');
	button.setAttribute('class', 'active');
	button.value = '*';
	button.innerText = 'All';

	filterDesktop.appendChild(h4);
	filterDesktop.appendChild(button);
	header.appendChild(filterDesktop);


	// Create Mobile Filter Bar and append to Main element
	var div = document.createElement('div');
	div.setAttribute('id', 'filter-bar-mobile');
	div.setAttribute('class', 'flexbox center');
	var filterMobile = div;

	var h4 = document.createElement('h4');
	h4.innerText = 'Filter: ';

	var div = document.createElement('div');
	div.setAttribute('class', 'dropdown');
	var dropdown = div;

	var select = document.createElement('select');
	var span = document.createElement('span');
	var i = document.createElement('i');
	i.setAttribute('class', 'icon-angle-up');

	var option = document.createElement('option');
	option.setAttribute('value', '*');
	option.innerText = 'All';

	select.appendChild(option);
	span.appendChild(i);
	dropdown.appendChild(select);
	dropdown.appendChild(span);
	filterMobile.appendChild(h4);
	filterMobile.appendChild(dropdown);
	main.appendChild(filterMobile);


	// Function to create the Buttons and select Options
	// from our filter option data.
	function createFilterUI(uniqueFilterOption) {

		var value = uniqueFilterOption;
		var valueText = value.replace(/^./, value[0].toUpperCase()); // First letter uppercase.

		// Create buttons for Desktop Filter
		var button = document.createElement('button');
		button.setAttribute('type', 'button');
		button.value = value;
		button.innerText = valueText;

		filterDesktop.appendChild(button);

		// Create select options for Mobile Filter
		var option = document.createElement('option');
		option.setAttribute('value', value);
		option.innerText = valueText;

		select.appendChild(option);

	}


	// Filter function
	function isoFilter(filterValue) {

		var regexp = filterValue;

		iso.arrange({filter: function(el) {

			if (regexp === '*') return true;

			var filters = el.dataset.filterValues;
			var searchResult = filters.match(regexp);

			return searchResult;

		}});

		// DELETE THIS???
		// When grid rearrange is complete update the lazy loading...
		// iso.on('arrangeComplete', function() {
		//
		// 	// REFACTOR THIS WHEN I SORT LAZYLOADING
		// 	$(window).trigger('lazyupdate');
		//
		// });

		// Back to the top of the page.
		window.scrollTo(0, 0);

	}


	// CREATE BUTTONS AND SELECT OPTION ELEMENTS FROM FILTER SELECTORS
	// Get all Isotope grid items
	var isotopeItems = isotopeGrid.querySelectorAll('.grid-item');

 	// Create empty arrays
	var allFilterOptions = [];
	var uniqueFilterOptions = [];

	// Loop over all grid items.
	for (var i = 0; i < isotopeItems.length; i++) {

		var isotopeItem = isotopeItems[i];

		var arrayItems = isotopeItem.dataset.filterValues.split(' ');

		arrayItems.forEach(function(arrayItem) {

			allFilterOptions.push(arrayItem);

		});

	}

	// Return unique options (remove duplicates)
	var uniqueFilterOptions = allFilterOptions.filter(function(item, index) {

		return allFilterOptions.indexOf(item) >= index;

	});

	// For every unique filter option create a button or select option element
	for (var j = 0; j < uniqueFilterOptions.length; j++) {

		var uniqueFilterOption = uniqueFilterOptions[j];

		createFilterUI(uniqueFilterOption);

	}


	// START ISOTOPE GRID
	var iso = new Isotope(isotopeGrid, {

		itemSelector: '.grid-item',
		layoutMode: 'fitRows',
		transitionDuration: '0.3s',

	});

	var filterButtons = filterDesktop.querySelectorAll('button');
	var filterSelect = filterMobile.querySelector('select');

	// Filter when Filter Bar Button clicked...
	filterButtons.forEach(function(button) {

		button.addEventListener('click', function(e) {

			var filterValue = e.target.value;

			e.target.classList.add('active');

			for (var i = 0; i < filterButtons.length; i++) {

				// If the link is the one clicked, skip it
				if (filterButtons[i] === e.target) continue;

				// Remove the .active class
				filterButtons[i].classList.remove('active');

			}

			isoFilter(filterValue);

		});

	});

	// When Filter Select is changed...
	filterSelect.addEventListener('change', function() {

		var filterValue = filterSelect.value;

		isoFilter(filterValue);

	}, false);



	// Create a link to the Events Archive section.
	var events = document.querySelector('section#events');
	var eventsArchive = document.querySelector('section#events-archive');

	if (events) {

		var a = document.createElement('a');
		a.setAttribute('href', '../events-archive');
		a.setAttribute('title', 'Events Archive');
		a.setAttribute('class', 'previous-events');
		a.innerText = 'Events Archive';

		filterDesktop.appendChild(a);

	}

	if (eventsArchive) {

		var a = document.createElement('a');
		a.setAttribute('href', '../events');
		a.setAttribute('title', 'Future Events');
		a.setAttribute('class', 'previous-events');
		a.innerText = 'Future Events';

		filterDesktop.appendChild(a);

	}

}
